import { render, staticRenderFns } from "./CreateTest.vue?vue&type=template&id=028b1105&lang=pug"
import script from "./CreateTest.vue?vue&type=script&lang=js"
export * from "./CreateTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports